import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { CheckmarkIcon } from "components/page-components/Icons/small"
import { useStaticQuery, graphql } from "gatsby"

export const NoticepagePaywallHalfpage = ({ ZoneOfRequest }) => {
  const { rocket_img } = useStaticQuery(graphql`
    query {
      rocket_img: file(
        relativePath: { eq: "illustrations/general/rocket-illustration.png" }
      ) {
        childImageSharp {
          gatsbyImageData(
            width: 120
            formats: [AUTO, AVIF]
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
    }
  `)

  return (
    <div
      className="box is-hidden-print is-hidden-mobile has-text-mitternachtsblau mt-6 is-flex is-flex-direction-column mb-4"
      style={{ position: "sticky", top: "6rem" }}
    >
      <GatsbyImage
        {...{
          alt: "Jetzt B_I ausschreibungsdatenbank kostenlos testen",
          image: rocket_img.childImageSharp.gatsbyImageData,
          className: "mx-auto my-4",
        }}
      />
      <p className="title is-4 mt-5 has-text-centered has-text-mitternachtsblau">
        Jetzt <span className="is-underlined">kostenfrei</span> testen und
        durchstarten.
      </p>
      <p className="title is-8 mt-5 has-text-evergabe ml-5">
        Von folgenden Benefits profitieren
      </p>

      {[
        "10.000+ Auftragschancen für Ihr Business",
        `${ZoneOfRequest === 4 ? "Aufträge" : "Ausschreibungen"} für alle Leistungen`,
        "Experten-Support",
      ].map((benefit, index) => (
        <div className="is-flex ml-5 mb-4" key={`benefit-${index}`}>
          <span className="my-auto icon">
            <CheckmarkIcon {...{ color: "#0EAA2D" }} />
          </span>
          <p className="has-text-mitternachtsblau my-auto ml-3">{benefit}</p>
        </div>
      ))}

      <a
        href={`${process.env.GATSBY_AD_SOFTWARE_PRODUCT_REGISTER_ADDRESS}${process.env.GATSBY_AD_SOFTWARE_PRODUCT_FREE_TEST_ID}`}
        className="button is-sonnengelb is-fullwidth mt-5"
      >
        Test starten
      </a>
    </div>
  )
}
